import TrendyolSettings from './TrendyolSettings';

export default TrendyolSettings;
